import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type DeleteOpenDockWarehouseAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
}

export type DeleteOpenDockWarehouseAppointmentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function deleteOpenDockWarehouseAppointmentFactory({
  shipmentRepository,
}: DeleteOpenDockWarehouseAppointmentFactoryDependencies) {
  return async function submit(
    params: DeleteOpenDockWarehouseAppointmentParams,
    config?: { signal?: AbortSignal }
  ) {
    const { shipmentUUID, stopIndex } = params
    try {
      return await shipmentRepository.deleteOpenDockWarehouseAppointment({
        shipmentUUID,
        stopIndex,
        config,
      })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not reset appointment', { cause: error as Error })
    }
  }
}

export function deleteOpenDockWarehouseAppointment(
  params: DeleteOpenDockWarehouseAppointmentParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = deleteOpenDockWarehouseAppointmentFactory({ shipmentRepository })

  return submit(params, config)
}
